import React from 'react';
import { Heading } from '../typography/Heading';
import { Text } from '../typography/Text';

export function TermsOfPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <Heading level={1} className="mb-8">Terms of Service</Heading>
      
      <div className="prose max-w-none space-y-8">
        <section>
          <Heading level={2} className="mb-4">1. Acceptance of Terms</Heading>
          <Text>
            By accessing and using hiiroo ("the Service"), you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our service.
          </Text>
        </section>

        <section>
          <Heading level={2} className="mb-4">2. Description of Service</Heading>
          <Text>
            hiiroo provides AI-powered cover letter generation services. While we strive to provide high-quality results, we cannot guarantee employment outcomes or interview success rates.
          </Text>
        </section>

        <section>
          <Heading level={2} className="mb-4">3. User Accounts</Heading>
          <Text>
            You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account. You must immediately notify us of any unauthorized use of your account.
          </Text>
        </section>

        <section>
          <Heading level={2} className="mb-4">4. User Content</Heading>
          <Text>
            You retain all rights to any content you submit to the Service. By using our service, you grant us a license to process and store your content for the purpose of generating cover letters.
          </Text>
        </section>

        <section>
          <Heading level={2} className="mb-4">5. Payment Terms</Heading>
          <Text>
            Some features of our Service require payment. All payments are non-refundable unless otherwise stated. We reserve the right to modify our pricing with appropriate notice to users.
          </Text>
        </section>

        <section>
          <Heading level={2} className="mb-4">6. Intellectual Property</Heading>
          <Text>
            The Service and its original content, features, and functionality are owned by hiiroo and are protected by international copyright, trademark, and other intellectual property laws.
          </Text>
        </section>

        <section>
          <Heading level={2} className="mb-4">7. Limitation of Liability</Heading>
          <Text>
            hiiroo shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use the Service.
          </Text>
        </section>

        <section>
          <Heading level={2} className="mb-4">8. Termination</Heading>
          <Text>
            We reserve the right to terminate or suspend your account and access to the Service immediately, without prior notice, for any violation of these Terms.
          </Text>
        </section>

        <section>
          <Heading level={2} className="mb-4">9. Changes to Terms</Heading>
          <Text>
            We reserve the right to modify these terms at any time. We will notify users of any material changes via email or through the Service.
          </Text>
        </section>

        <section>
          <Heading level={2} className="mb-4">10. Contact Information</Heading>
          <Text>
            For any questions regarding these terms, please contact us at:
          </Text>
          <Text className="mt-2">
            Email: <a href="mailto:info@hiiroo.com" className="text-primary hover:underline">
              info@hiiroo.com
            </a>
          </Text>
        </section>
      </div>
    </div>
  );
}